/* src/components/DebugDisplay/DebugDisplay.svelte generated by Svelte v3.48.0 */
import {
	SvelteComponent,
	claim_text,
	detach,
	init,
	insert_hydration,
	noop,
	safe_not_equal,
	text
} from "svelte/internal";

function create_fragment(ctx) {
	let t;

	return {
		c() {
			t = text(";");
		},
		l(nodes) {
			t = claim_text(nodes, ";");
		},
		m(target, anchor) {
			insert_hydration(target, t, anchor);
		},
		p: noop,
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { display } = $$props;
	const isDev = process.env.componentType === 'browser' && window && window.location.hostname.includes('localhost');

	$$self.$$set = $$props => {
		if ('display' in $$props) $$invalidate(0, display = $$props.display);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*display*/ 1) {
			$: if (isDev) console.log(display);
		}
	};

	return [display];
}

class DebugDisplay extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { display: 0 });
	}
}

export default DebugDisplay;